import _map from "lodash/map";
import _sortBy from "lodash/sortBy";
import { IBasicInfoViewModel } from "pages/MainPage/components/BasicInfoSection/viewModels";
import { mapMeasurements } from "./map-measurements";
import { mapVocalRange, mapVocalAge } from "./map-vocal";
import { mapFacets } from "./map-facets";
import { applyVisibilityAwareFields, mapEthnicity } from "./map-visibility";
import { mapCommonFields } from "./map-common-fields";
import { convertFacetsToView } from "./convert-facets-to-view";
import { ConverterParams } from "./types";

export function convertBasicInfoToView({
  basicInfo,
  locations,
  facets,
  t,
  isViewMode,
}: ConverterParams): IBasicInfoViewModel {
  const facetsView = convertFacetsToView(facets);
  const locationsValue = _map(_sortBy(locations, "position"), "value");

  const model: IBasicInfoViewModel = {
    ...mapMeasurements(basicInfo, t),
    ...mapFacets(basicInfo, facetsView),
    ...mapVocalRange(basicInfo, facetsView, t),
    ...mapVocalAge(basicInfo, t),
    ...mapCommonFields(basicInfo, t),
    locations: locationsValue,
  };

  const visibilityFields = applyVisibilityAwareFields({
    model,
    basicInfo,
    isViewMode,
    t,
  });
  const modelWithVisibility: IBasicInfoViewModel = {
    ...model,
    ...visibilityFields,
  };

  return {
    ...modelWithVisibility,
    ...mapEthnicity(modelWithVisibility, basicInfo, isViewMode),
  };
}
